import React from 'react';
import { Card } from 'react-bootstrap';

import GenericCardRenderItems from './GenericCardRenderItems';
import GenericSimpleRenderItems from './GenericSimpleRenderItems';

const ComplementoCartaPorteMercanciasResumen = ({ data = {} }) => {
  const render = (item) => (
    <GenericCardRenderItems
      key={item.id}
      data={item}
      labels={labels}
    />
  );

  return (
    <>
      {!!data.Mercancias.Mercancia && (
        <>
          <div className="d-block mt-3 mb-2">
            <strong>Mercancias</strong>
          </div>

          <Card className="mb-2">
            <Card.Body>
              <GenericSimpleRenderItems
                data={data.Mercancias}
                labels={resumenLabels(data)}
              />

              {data.Mercancias.Mercancia.map(render)}
            </Card.Body>
          </Card>
        </>
      )}
    </>
  );
};

const labels = [
  {
    label: 'Bienes Transpotados',
    index: 'BienesTransp',
  },
  {
    label: 'Descripción',
    index: 'Descripcion',
  },
  {
    label: 'Cantidad',
    index: 'Cantidad',
  },
  {
    label: 'Clave Unidad',
    index: 'ClaveUnidad',
  },
  {
    label: 'Peso en Kg',
    index: 'PesoEnKg',
  },
];

const resumenLabels = (data = {}) => {
  return [
    {
      label: 'Logística Recolección/Devolución',
      index: 'LogisticaInversaRecoleccionDevolucion',
    },
    {
      label: 'Peso Bruto Total',
      index: 'PesoBrutoTotal',
    },
    {
      label: 'Unidad Peso',
      index: 'UnidadPeso',
    },
    {
      label: 'Peso Neto Total',
      index: 'PesoNetoTotal',
    },
    {
      label: 'Número Total Mercancias',
      index: 'NumTotalMercancias',
    },
    {
      label: 'Cargo por Tasación',
      index: 'CargoPorTasacion',
    },
  ];
};

export default ComplementoCartaPorteMercanciasResumen;
